import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  DSBottomSheet,
  DSButton,
  DSRADIO_BUTTON_POSITION,
  DSRadio,
} from '@repo/design-system/index'
import { QIcon_chevron_down } from '@repo/icons/index'
import classNames from 'classnames'
import { SetStateAction, useMemo, useState } from 'react'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import { CurrentUser } from '../../../../model/Common/common.interface'
import { ANSWER_SHARE_STATUS } from '../../../../model/answer.interface'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { LOCALE_EN, LOCALE_KO } from '../../../../modules/i18n/config'
import { n_common, n_lesson_prep, s_preparation } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { DATA_REF_KEY } from '../../../../modules/ids/e2e/student'
import { CoursekeyquestionsReordering } from '../../../../modules/lessonTypes'
import { COLORS, SESSION_ROLE } from '../../../../modules/vars'
import { DivPropType } from '../../../basic/DivPropsType'
import GoogleTranslate from '../../GoogleTranslate'
import GoogleTranslateBtn from '../../GoogleTranslateBtn'

interface CardTextareaPropsType extends DivPropType {
  inputref?: any
  cardClass?: any
  bodyClass?: any
  className?: any
  disabled?: any
  style?: any
  noBorder?: any
  rounded?: any
  children?: any
  dataRef?: string
}

export const CardTextarea = ({
  inputref,
  cardClass,
  bodyClass,
  className,
  disabled,
  style,
  noBorder,
  rounded,
  children,
  dataRef,
  ...others
}: CardTextareaPropsType) => {
  return (
    <>
      <div className={classNames(classNames('', bodyClass))}>
        <textarea
          disabled={disabled}
          className={classNames(
            'Body2-14Md scrollbar-new` h-[142px] w-[320px] w-full resize-none rounded-[8px] !border-none bg-gray-50 p-[16px] !ring-0',
            disabled ? 'text-gray-400' : 'text-black',
            className
          )}
          {...others}
        >
          {children}
        </textarea>
      </div>
    </>
  )
}

interface isEditable extends CoursekeyquestionsReordering {
  editable: boolean
}

export const SHARE_STATUS = {
  0: n_lesson_prep.answer_scope_option1,
  1: n_lesson_prep.answer_scope_option3,
  2: n_lesson_prep.answer_scope_option2,
}

export const shareOptions = (isMaterial) => {
  const options = [
    { label: n_lesson_prep.answer_scope_option1, value: ANSWER_SHARE_STATUS.PUBLIC },
    { label: n_lesson_prep.answer_scope_option2, value: ANSWER_SHARE_STATUS.ME },
  ]

  if (!isMaterial) {
    options.push({ label: n_lesson_prep.answer_scope_option3, value: ANSWER_SHARE_STATUS.TUTOR_AND_ME })
  }

  return options
}

interface AnswerItemPropsType {
  answer: string | null | undefined
  setAnswer: (value: string | null | undefined) => void
  isEditable: any
  setIsEditable: (value: SetStateAction<isEditable[] | null>) => void
  activeQuestionId: number
  lessonId: number
  currentUser: CurrentUser
  isReview: boolean
  isLesson: boolean
  isPast: () => boolean
  handleSubmitAnswer?: any
  onBlur: () => void
  selectedShareState: any
  setSelectedShareState: any
}

const AnswerItem = ({
  answer,
  setAnswer,
  isEditable,
  setIsEditable,
  activeQuestionId,
  lessonId,
  handleSubmitAnswer,
  onBlur,
  currentUser,
  isReview,
  isLesson,
  isPast,
  selectedShareState,
  setSelectedShareState,
}: AnswerItemPropsType) => {
  const { t, locale } = useTranslation()
  const isWebview = useIsWebview()
  const isMobile = useIsMobile(undefined, 1041)
  const isMobileForRadio = useIsMobile()
  const { sendClickEvent } = useEventTracking()
  const router = useAppRouter()
  const isLessonPage = useMemo(() => {
    const lessonId = router.query.lessonId
    return router.asPath.includes('/lessons') && Boolean(lessonId) && lessonId !== 'undefined'
  }, [router.asPath, router.query.lessonId])

  const currentAnswer = isEditable?.find((item, idx) => Number(item.question_number) == activeQuestionId)
  const currentIsEditable = isEditable?.find((item, idx) => Number(item.question_number) == activeQuestionId)

  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const [showGoogleTranslate, setShowGoogleTranslate] = useState(false)

  const onChangeAnswer = ({ target }) => {
    // CardTextarea에서 입력될떼 setAnswer을 함.
    setAnswer(target.value)
  }

  // 수정 하기 버튼 (input 활성화)
  const handleModifyAnswer = () => {
    // activeQuestionId 에 맞게 setIsEditable 사용
    const updateIsEditable = [...isEditable]
    updateIsEditable.map((item, idx) => {
      if (Number(item.question_number) == activeQuestionId) {
        updateIsEditable[idx].editable = !item.editable
        setIsEditable(updateIsEditable)
      }
    })
  }

  const isParent = currentUser.session_role == SESSION_ROLE.PARENT
  const IS_INPUT_NOT_WRITABLE = isLesson || isParent

  const onClickBottomSheet = () => {
    setShowBottomSheet(true)
  }

  const closeBottomSheet = (e) => {
    e.stopPropagation()
    setShowBottomSheet(false)
  }

  const onChangeTab = (value) => {
    if (isLessonPage) {
      // 수업 준비 화면인 경우
      const updateIsEditable = [...isEditable]
      updateIsEditable.map((item, idx) => {
        if (item.question_number == activeQuestionId) {
          // if (!updateIsEditable[idx].student_answer) {
          //   return
          // }
          if (!updateIsEditable[idx].student_answer) {
            // 특정 인덱스의 `student_answer`가 없으면 빈 객체로 초기화합니다.
            updateIsEditable[idx].student_answer = {}
          }
          // `student_answer` 속성의 `content` 값을 지정합니다.
          updateIsEditable[idx].student_answer.content = answer
          updateIsEditable[idx].student_answer.share_status = value
          setIsEditable(updateIsEditable)
          setSelectedShareState(value)
        }
      })
    } else {
      // 교재 상세
      setSelectedShareState(value)
    }
  }

  return (
    <>
      {(locale == LOCALE_KO || locale == LOCALE_EN) && showGoogleTranslate && (
        <GoogleTranslate lessonId={lessonId} onClose={() => setShowGoogleTranslate(false)} />
      )}
      <div>
        <CardTextarea
          id={`answer-text-field-${activeQuestionId}`}
          dataRef={DATA_REF_KEY.inp_answer}
          disabled={IS_INPUT_NOT_WRITABLE || !currentIsEditable?.editable || isReview}
          onChange={(e) => {
            onChangeAnswer(e)
          }}
          onBlur={onBlur}
          minRows={4}
          value={answer}
          placeholder={
            isLesson ? t(s_preparation.no_saved_answer) : isPast() ? '' : t(n_lesson_prep.answer_placeholder)
          }
          className={classNames({
            'bg-gray-50': !currentIsEditable?.editable,
          })}
        />
      </div>
      {!isPast() && (
        <div className="row mt-[4px]">
          <div className={classNames('flex flex-col', isMobile ? 'space-y-12' : 'space-y-4')}>
            {/* 나만보기 체크, 수정 필요(튜터 보이기, 나만 보기, 모두 보기로 옵션 변경) */}
            <div className="mt-[22px] flex flex-col items-start space-y-[6px] sm:flex-row sm:items-center sm:space-y-0 sm:space-x-[12px]">
              <div className="text-[16px] font-bold text-gray-600">{t(n_lesson_prep.answer_scope)}</div>
              {isWebview || isMobileForRadio ? (
                <>
                  <div
                    onClick={onClickBottomSheet}
                    className={classNames(
                      [!currentIsEditable?.editable ? 'pointer-events-none bg-gray-50' : 'bg-white'],
                      'flex w-full flex-row items-center rounded-[8px] border-[1.5px] border-gray-300 px-[12px] py-[8px]'
                    )}
                  >
                    <span className="text-[16px] font-medium">
                      {t(SHARE_STATUS[selectedShareState ? selectedShareState : 0])}
                    </span>
                    <QIcon_chevron_down className="ml-auto h-12 w-12" />
                  </div>
                  {showBottomSheet && (
                    <DSBottomSheet
                      id={`bottom-sheet-${activeQuestionId}`}
                      isOpen={showBottomSheet}
                      setIsOpen={setShowBottomSheet}
                      closeOnDrag
                      closeOnDim
                    >
                      <div className="z-20 flex h-full w-full flex-col">
                        <div className="mb-[44px] flex flex-col gap-[20px] px-[20px] pt-[4px]">
                          <div className="flex flex-col gap-[16px]">
                            {shareOptions(!isLessonPage).map((item, index) => (
                              <div key={index} className="flex justify-between">
                                <button
                                  className="flex flex-row gap-x-[8px] py-[16px] px-[20px]"
                                  onClick={async (e) => {
                                    onChangeTab(item.value)
                                    closeBottomSheet(e)
                                  }}
                                >
                                  {t(item.label)}
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </DSBottomSheet>
                  )}
                </>
              ) : (
                // to-do: onChangeTab 걸기
                <DSRadio
                  controlSelected={[selectedShareState, setSelectedShareState]}
                  buttonPosition={DSRADIO_BUTTON_POSITION.LEFT}
                  containerClassName={'flex flex-row space-x-[8px]'}
                >
                  <DSRadio.Item value={ANSWER_SHARE_STATUS.PUBLIC} disabled={!currentIsEditable?.editable || isReview}>
                    {t(n_lesson_prep.answer_scope_option1)}
                  </DSRadio.Item>
                  <DSRadio.Item value={ANSWER_SHARE_STATUS.ME} disabled={!currentIsEditable?.editable || isReview}>
                    {t(n_lesson_prep.answer_scope_option2)}
                  </DSRadio.Item>
                  {isLessonPage && (
                    <DSRadio.Item
                      value={ANSWER_SHARE_STATUS.TUTOR_AND_ME}
                      disabled={!currentIsEditable?.editable || isReview}
                    >
                      {t(n_lesson_prep.answer_scope_option3)}
                    </DSRadio.Item>
                  )}
                </DSRadio>
              )}
            </div>
            <div className={classNames('flex  space-x-[8px]', isMobile ? '' : 'mt-0 ml-auto')}>
              {isWebview || (locale != LOCALE_KO && locale != LOCALE_EN) ? (
                <></>
              ) : (
                <div className={classNames(isMobile ? 'w-full' : '')}>
                  <GoogleTranslateBtn
                    setShowGoogleTranslate={setShowGoogleTranslate}
                    showGoogleTranslate={showGoogleTranslate}
                    customTxtColor={COLORS.BLACK}
                    customBorderColor={COLORS.GRAY300}
                    customSize={BUTTON_SIZE.MD}
                    className="h-[48px]"
                  />
                </div>
              )}
              <div className={classNames(isMobile ? 'w-full' : '')}>
                {currentIsEditable?.editable ? ( // 수정하기 버튼을 누르거나 사용자가 답변을 입력 했을 때
                  <div>
                    <DSButton
                      onClick={(e) => {
                        sendClickEvent({ button_name: 'lesson_answer_save' })
                        if (isLessonPage) {
                          handleSubmitAnswer({
                            id: currentAnswer.id,
                            content: answer,
                            shareStatus: selectedShareState || 0,
                            isEditable,
                            setIsEditable,
                            activeQuestionId,
                            lessonId,
                          })
                        } else {
                          // 교재에서 답변 다는 경우
                          handleSubmitAnswer({
                            course_id: lessonId, // to-do: lessonId 대신 다른 파라미터 이름 사용?
                            question_number: activeQuestionId,
                            content: answer,
                            shareStatus: selectedShareState || 0,
                            isEditable,
                            setIsEditable,
                          })
                        }
                      }}
                      size={BUTTON_SIZE.MD}
                      type={BUTTON_TYPE.SOLID}
                      customBorderColor={COLORS.PURPLE600}
                      customBgColor={COLORS.PURPLE600}
                      className="border-[1px]"
                      disabled={answer ? false : true}
                    >
                      <DSButton.Label>{t(n_common.btn_save_full)}</DSButton.Label>
                    </DSButton>
                  </div>
                ) : (
                  <div>
                    <DSButton
                      onClick={(e) => {
                        handleModifyAnswer()
                      }}
                      size={BUTTON_SIZE.MD}
                      type={BUTTON_TYPE.OUTLINE}
                      customBorderColor={COLORS.PURPLE600}
                      disabled={isReview}
                    >
                      <DSButton.Label customTxtColor={COLORS.PURPLE600}>
                        {t(n_lesson_prep.answer_edit_answer)}
                      </DSButton.Label>
                    </DSButton>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default AnswerItem
